import {
  type TicketMessage as TicketMessageType,
  TicketMessageType as TicketMessageTypeKeys,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import TicketBotMessage from '../TicketBotMessage/TicketBotMessage';
import TicketMessageComment from '../TicketMessageComment/TicketMessageComment';
import TicketMessageMedia from '../TicketMessageMedia/TicketMessageMedia';
import TicketMessagePart from '../TicketMessagePart/TicketMessagePart';
import TicketNewCommentBadge from '../TicketNewCommentBadge/TicketNewCommentBadge';
import TicketRating from '../TicketRating/TicketRating';

interface TicketMessageProps {
  message: TicketMessageType;
  ticketId: string;
  createdAt?: string;
  externalJiraId?: string;
}

const TicketMessage = (props: TicketMessageProps) => {
  const { ticketId, message } = props;
  return (
    <div className="mr-8 pb-3">
      {message.type === TicketMessageTypeKeys.NEW_MESSAGE_INDICATOR && <TicketNewCommentBadge />}
      {message.type === TicketMessageTypeKeys.COMMENT && <TicketMessageComment {...message} />}
      {message.type === TicketMessageTypeKeys.BOT_MESSAGE && <TicketBotMessage {...message} />}
      {message.type === TicketMessageTypeKeys.MEDIA && <TicketMessageMedia {...message} ticketId={ticketId} />}
      {message.type === TicketMessageTypeKeys.PART && (
        <TicketMessagePart ticketId={ticketId} {...message} isFromMe={false} showOptions={true} />
      )}
      {message.type === TicketMessageTypeKeys.RATING && <TicketRating {...message} ticketId={ticketId} />}
    </div>
  );
};

export default TicketMessage;
